<div *ngIf="saving">
	<div class="flex align-items-center justify-content-center w-full pb-8 mb-8">
		<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
	</div>
</div>

<div *ngIf="!saving">
	<div class="grid" *ngIf="!enabledLog">
		<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
			<p-tag icon="pi cm-alert" [value]="('LOGS_NOT_ENABLE_NOW' | translate)" severity="warning"></p-tag>
			<p-toggleButton [(ngModel)]="enabledLog" onLabel="{{'DISABLE_LOG' | translate}}"
				offLabel="{{'ENABLE_LOG' | translate}}" (onChange)="enableLog($event)" *ngIf="online && configured" />
		</div>
	</div>
	<form [formGroup]="filterGroup">
		<div class="grid mt-0 px-3">
			<div [class]="col4Responsive()">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-900"
					[ngClass]="simpleInputTextLayout('borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">{{
						'START_DATE_TIME' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="simpleInputTextLayout('borderInput')">
						<p-calendar [showIcon]="true" formControlName="startDateTime" [showButtonBar]="true"
							placeholder="{{'START_DATE_TIME' | translate}}" id="events-input-deviceFilter"
							[ngClass]="dynamicInputTextWidth()" styleClass="{{ dynamicInputTextWidth() }}"
							inputStyleClass="pl-6 border-noround-right surface-900" [minDate]="minDate" [maxDate]="maxDate"
							[defaultDate]="today" [showTime]="true" [hourFormat]="24">
						</p-calendar>
					</div>
				</div>
			</div>
			<div [class]="col4Responsive()">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-900"
					[ngClass]="simpleInputTextLayout('borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">{{
						'END_DATE_TIME' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="simpleInputTextLayout('borderInput')">
						<p-calendar [showIcon]="true" formControlName="endDateTime" [showButtonBar]="true"
							placeholder="{{'END_DATE_TIME' | translate}}" id="events-input-deviceFilter"
							[ngClass]="dynamicInputTextWidth()" styleClass="{{ dynamicInputTextWidth() }}"
							inputStyleClass="pl-6 border-noround-right surface-900" [minDate]="minDate" [defaultDate]="today"
							[maxDate]="maxDate" [showTime]="true" [hourFormat]="24">
						</p-calendar>
					</div>
				</div>
			</div>
			<div [class]="col4Responsive()">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-900"
					[ngClass]="simpleInputTextLayout('borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">{{
						'UNITS' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="simpleInputTextLayout('borderInput')">
						<span class="p-input-icon-left" [class]="dynamicInputTextWidth()">
							<i class="pi cm-search"></i>
							<input formControlName="unitName" pInputText type="text" [ngClass]="dynamicInputTextWidth()"
								class="pr-6" id="call-access-log-input-search" placeholder="{{ 'SEARCH' | translate }}"
								maxlength="254" class="surface-900"/>
						</span>
					</div>
				</div>
			</div>
			<div *ngIf="!onExtendedMobile()" class="col-12 flex justify-content-center gap-4">
				<p-button icon="pi cm-reload" label="{{ 'REFRESH' | translate }}" (click)="refresh()" [rounded]="false" [text]="true"
					severity="primary" styleClass="font-bold border-primary surface-900 hover:bg-blue-900 w-16rem">
				</p-button>
				<p-button icon="pi cm-download" label="{{ 'EXPORT' | translate }}" (click)="exportToCsv()"
					[disabled]="logs.length<=0"
					[rounded]="false" [text]="true" severity="primary" styleClass="font-bold border-primary surface-900 hover:bg-blue-900 w-16rem">
				</p-button>
			</div>
			<div *ngIf="onExtendedMobile()" class="col-12 pt-0">
				<div class="col-12 px-0">
					<p-button icon="pi cm-reload" label="{{ 'REFRESH' | translate }}" (click)="refresh()" [rounded]="false" [text]="true"
						severity="primary" styleClass="font-bold border-primary surface-900 hover:bg-blue-900 w-full pr-5">
					</p-button>
				</div>
				<div class="col-12 px-0">
					<p-button icon="pi cm-download" label="{{ 'EXPORT' | translate }}" (click)="exportToCsv()"
						[disabled]="logs.length<=0"
						[rounded]="false" [text]="true" severity="primary" styleClass="font-bold border-primary surface-900 hover:bg-blue-900 w-full pr-5">
					</p-button>
				</div>
			</div>
		</div>
	</form>

	<div class="grid mt-0">
		<div class="col-12">
			<div class="card border-round">
				<p-table #tableCallUnitEventList dataKey="Id" [value]="logs" [totalRecords]="resultLength" [rows]="pageSize"
					[lazy]="true" [loading]="logsLoading" [paginator]="true" (onLazyLoad)="loadLogs($event)"
					[showCurrentPageReport]="true" currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}" [autoLayout]="true"
					sortField="EventDate" [sortOrder]="-1" responsiveLayout="stack">
					<!-- <ng-template pTemplate="caption">
										<div class="flex flex-wrap justify-content-end gap-2">
											<p-button label="{{ 'EXPAND_ALL' | translate }}" icon="pi pi-plus" text severity="primary" (onClick)="expandAll()" />
											<p-button label="{{ 'COLLAPSE_ALL' | translate }}" icon="pi pi-minus" text severity="primary" (onClick)="collapseAll()" />
										</div>
									</ng-template> -->
					<ng-template pTemplate="header">
						<tr>
							<th style="width: 5rem"></th>
							<th>
								<div pSortableColumn="EventDate" class="flex align-items-center justify-content-center">
									{{ 'EVENT_DATE' | translate }}
									<p-sortIcon field="EventDate"></p-sortIcon>
								</div>
							</th>
							<th>
								<div class="flex align-items-center justify-content-center">
									{{ 'BUTTON' | translate }}
								</div>
							</th>
							<th>
								<div class="flex align-items-center justify-content-center">
									{{ 'UNITS' | translate }}
								</div>
							</th>
							<th>
								<div class="flex align-items-center justify-content-center">
									{{ 'CALL_STATUS' | translate }}
								</div>
							</th>
						</tr>
					</ng-template>
					<ng-template pTemplate="body" let-row let-expanded="expanded">
						<tr>
							<td>
								<p-button *ngIf="getCallsEventLenght(row.CallsEvent)" [pRowToggler]="row" [rounded]="true"
									styleClass="surface-900 hover:bg-primary border-1 border-600"
									[icon]="expanded ? 'pi cm-angle-down' : 'pi cm-angle-right'" />
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'EVENT_DATE' | translate }}</span>{{
								getDate(row.EventDate) |
								localizedDate: 'medium':'UTC' }}
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'BUTTON' | translate }}</span>{{
								getButtonInfo(row.ButtonId) }}
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'UNITS' | translate }}</span>{{ row.UnitName }}
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'CALL_STATUS' | translate }}</span>
								<p-tag *ngIf="getCallsEventLenght(row.CallsEvent)" [value]="getResultInfo(getLastResult(row.CallsEvent))"
									[severity]="getResultColor(getLastResult(row.CallsEvent))"></p-tag>
								<p-tag *ngIf="!getCallsEventLenght(row.CallsEvent)" value="{{ 'ERROR' | translate }}"
									[severity]="secondary"></p-tag>
							</td>
						</tr>
					</ng-template>
					<ng-template pTemplate="emptymessage">
						<tr>
							<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
						</tr>
					</ng-template>
					<ng-template pTemplate="rowexpansion" let-logs>
						<tr class="surface-400">
							<td colspan="6">
								<div class="w-full" [class]="onExtendedMobile() ? 'px-2' : 'px-7'">
									<p-table #tableCallsEventList dataKey="Id" [value]="logs.CallsEvent" [paginator]="false"
										[showCurrentPageReport]="true" currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}"
										[autoLayout]="true" responsiveLayout="stack">
										<ng-template *ngIf="getCallsEventLenght(logs.CallsEvent)" pTemplate="header">
						<tr>
							<th style="width: 5rem"></th>
							<th>
								<div class="flex align-items-center justify-content-center">
									{{ 'EVENT_DATE' | translate }}
								</div>
							</th>
							<th>
								<div class="flex align-items-center justify-content-center">
									{{ 'CONTACT' | translate }}
								</div>
							</th>
							<th>
								<div class="flex align-items-center justify-content-center">
									{{ 'PHONE_NUMBER' | translate }}
								</div>
							</th>
							<th>
								<div class="flex align-items-center justify-content-center">
									{{ 'CALL_STATUS' | translate }}
								</div>
							</th>
						</tr>
					</ng-template>
					<ng-template pTemplate="body" let-callsEvent let-expanded="expanded">
						<tr>
							<td>
								<p-button *ngIf="getCallsEventLenght(callsEvent.ActionEvents)"
									styleClass="surface-900 hover:bg-primary border-1 border-600" [pRowToggler]="callsEvent" [rounded]="true"
									[icon]="expanded ? 'pi cm-angle-down' : 'pi cm-angle-right'" />
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'EVENT_DATE' | translate }}</span>{{
								getDate(callsEvent.EventDate) | localizedDate: 'medium':'UTC' }}
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'CONTACT' | translate }}</span>{{
								callsEvent.Source
								}}
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'PHONE_NUMBER' | translate }}</span>{{
								callsEvent.Code }}
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'CALL_STATUS' | translate }}</span>
								<p-tag *ngIf="getResultColor(callsEvent.Result) !== ''" [value]="getResultInfo(callsEvent.Result)"
									[severity]="getResultColor(callsEvent.Result)"></p-tag>
							</td>
						</tr>
					</ng-template>
					<ng-template pTemplate="emptymessage">
						<tr>
							<td colspan="7" [class]="underTablet() ? 'flex justify-content-center' : ''">{{ 'TABLE_NO_ELEMENT'
								|
								translate }}</td>
						</tr>
					</ng-template>
					<ng-template pTemplate="rowexpansion" let-callsEvent>
						<tr>
							<td colspan="6">
								<div class="w-full" [class]="onExtendedMobile() ? 'px-2' : 'px-6'">
									<p-table #tableActionEventsList dataKey="Id" [value]="callsEvent.ActionEvents" [paginator]="false"
										[showCurrentPageReport]="true" currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}"
										[autoLayout]="true" responsiveLayout="stack">
										<ng-template *ngIf="getCallsEventLenght(callsEvent.ActionEvents)" pTemplate="header">
						<tr>
							<th>
								<div class="flex align-items-center justify-content-center">
									{{ 'EVENT_DATE' | translate }}
								</div>
							</th>
							<th>
								<div class="flex align-items-center justify-content-center">
									{{ 'DTMF_CODE' | translate }}
								</div>
							</th>
							<th>
								<div class="flex align-items-center justify-content-center">
									{{ 'DTMF_ACTION' | translate }}
								</div>
							</th>
							<th>
								<div class="flex align-items-center justify-content-center">
									{{ 'EXECUTION_STATE' | translate }}
								</div>
							</th>
						</tr>
					</ng-template>
					<ng-template pTemplate="body" let-actionEvents let-expanded="expanded">
						<tr class="surface-400">
							<td>
								<span class="p-column-title font-semibold">{{ 'EVENT_DATE' | translate }}</span>{{
								getDate(actionEvents.EventDate) | localizedDate: 'medium':'UTC' }}
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'DTMF_CODE' | translate }}</span>{{
								actionEvents.DtmfCode }}
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'DTMF_ACTION' | translate }}</span>{{
								actionEvents.Source }}
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'EXECUTION_STATE' | translate }}</span>
								<p-tag *ngIf="getActionResultColor(actionEvents.Result) !== ''"
									[value]="getActionResultInfo(actionEvents.Result)"
									[severity]="getActionResultColor(actionEvents.Result)"></p-tag>
							</td>
						</tr>
					</ng-template>
					<ng-template pTemplate="emptymessage">
						<tr>
							<td colspan="7" [class]="underTablet() ? 'flex justify-content-center' : ''">{{ 'TABLE_NO_ELEMENT'
								|
								translate }}</td>
						</tr>
					</ng-template>
				</p-table>
				</div>
				</td>
				</tr>
				</ng-template>
				</p-table>
				</div>
				</td>
				</tr>
				</ng-template>
				</p-table>
			</div>
		</div>
	</div>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton *ngIf="rejectButtonVisible" [label]="confDialog.rejectButtonLabel"
				[ngClass]="rejectButtonStyle" (click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>